<template>
  <section class="approval-section">
    <div class="approval-bg"></div>
    <div class="approval-inner">
      <div class="badge">OFFICIAL APPROVAL</div>

      <div class="divider-top">
        <span class="line"></span>
        <span class="diamond">◆</span>
        <span class="line"></span>
      </div>

      <h2 class="title">
        <span class="title-sub">청주시</span>
        <span class="title-main">사업계획 승인 완료</span>
      </h2>

      <div class="date-block">
        <span class="date-label">APPROVED</span>
        <span class="date-value">2026. 04. 22</span>
      </div>

      <div class="divider-bottom">
        <span class="line"></span>
        <span class="diamond">◆</span>
        <span class="line"></span>
      </div>

      <p class="caption">정식 인허가를 마친 안전한 사업지</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MobileApproval'
}
</script>

<style scoped>
.approval-section {
  position: relative;
  width: 100%;
  padding: 70px 24px;
  overflow: hidden;
  background:
    radial-gradient(ellipse at top, #1a2238 0%, #0a0e1a 70%);
}

/* 배경 글로우 */
.approval-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 320px;
  height: 320px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle,
    rgba(212, 175, 55, 0.18) 0%,
    rgba(212, 175, 55, 0.05) 40%,
    transparent 70%
  );
  pointer-events: none;
  animation: pulse-glow 4s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
  50% { transform: translate(-50%, -50%) scale(1.15); opacity: 1; }
}

.approval-inner {
  position: relative;
  z-index: 2;
  text-align: center;
}

/* 상단 골드 배지 */
.badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 4px;
  color: #d4af37;
  padding: 6px 14px;
  border: 1px solid rgba(212, 175, 55, 0.5);
  background: rgba(212, 175, 55, 0.05);
  margin-bottom: 28px;
}

/* 디바이더 */
.divider-top,
.divider-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 22px 0;
}

.line {
  width: 50px;
  height: 1px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(212, 175, 55, 0.7) 50%,
    transparent 100%
  );
}

.diamond {
  font-size: 8px;
  color: #d4af37;
}

/* 타이틀 */
.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.title-sub {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 6px;
}

.title-main {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.5px;
  line-height: 1.3;
  text-shadow: 0 0 20px rgba(212, 175, 55, 0.3);
}

/* 날짜 블록 */
.date-block {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 14px 28px;
  border: 1px solid rgba(212, 175, 55, 0.4);
  background: rgba(0, 0, 0, 0.25);
  position: relative;
}

.date-block::before,
.date-block::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border: 1px solid #d4af37;
}

.date-block::before {
  top: -1px;
  left: -1px;
  border-right: none;
  border-bottom: none;
}

.date-block::after {
  bottom: -1px;
  right: -1px;
  border-left: none;
  border-top: none;
}

.date-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 3px;
  color: rgba(212, 175, 55, 0.8);
}

.date-value {
  font-family: 'Georgia', 'Noto Serif KR', serif;
  font-size: 22px;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: 2px;
  text-shadow: 0 0 12px rgba(212, 175, 55, 0.4);
}

/* 캡션 */
.caption {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 1px;
  margin-top: 6px;
}

/* 작은 화면 */
@media (max-width: 380px) {
  .approval-section {
    padding: 60px 20px;
  }
  .badge {
    font-size: 9px;
    letter-spacing: 3px;
    padding: 5px 12px;
  }
  .title-sub {
    font-size: 12px;
    letter-spacing: 5px;
  }
  .title-main {
    font-size: 24px;
  }
  .date-value {
    font-size: 19px;
    letter-spacing: 1.5px;
  }
  .line {
    width: 38px;
  }
  .caption {
    font-size: 12px;
  }
}
</style>
